var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgIconCamera = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 14.17 12.75"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 7.08,
  cy: 7.08,
  r: 2.27,
  className: "icon-camera_svg__cls-1"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M12.75 1.42H10.5L9.21 0H5L3.66 1.42H1.42A1.42 1.42 0 0 0 0 2.83v8.5a1.43 1.43 0 0 0 1.42 1.42h11.33a1.43 1.43 0 0 0 1.42-1.42v-8.5a1.42 1.42 0 0 0-1.42-1.41m-5.67 9.2a3.54 3.54 0 1 1 3.54-3.54 3.54 3.54 0 0 1-3.54 3.54",
  className: "icon-camera_svg__cls-1"
})));
export default SvgIconCamera;